
(function() {
  function initScenarioSection(sectionElement) {
    var slider = sectionElement.querySelector('.swiper');
    var pagination = sectionElement.querySelector('.swiper-pagination');
    var swiperInstance = null;
    var resizeListener = null;

    if (!slider) return;

    function updateSwiper() {
      var screenWidth = window.innerWidth;
      var isMobile = screenWidth < 768;

      if (isMobile) {
        if (!swiperInstance) {
          swiperInstance = new Swiper(slider, {
            slidesPerView: '1.12',
            spaceBetween: 16,
            pagination: {
              el: pagination,
              clickable: true,
              type: 'bullets',
            },
            freeMode: false,
          });
        }
      } else {
        if (swiperInstance) {
          swiperInstance.destroy(true, true);
          swiperInstance = null;
        }
      }
    }

    // Initial check
    updateSwiper();

    // Resize check
    resizeListener = function() {
      updateSwiper();
    };
    window.addEventListener('resize', resizeListener);

    // Cleanup on section unload (theme editor)
    // Find the shopify section container
    var container = sectionElement.closest('.shopify-section');
    if (container) {
      container.addEventListener('shopify:section:unload', function() {
        window.removeEventListener('resize', resizeListener);
        if (swiperInstance) {
          swiperInstance.destroy(true, true);
          swiperInstance = null;
        }
      });
    }

    // PC Hover Effect Logic
    var blocks = sectionElement.querySelectorAll('.d3-2000-air-pdp-scenario_block');
    if (blocks.length > 0) {
      // Set first block as active initially
      blocks[0].classList.add('active');

      blocks.forEach(function(block) {
        block.addEventListener('mouseenter', function() {
          blocks.forEach(function(b) {
            b.classList.remove('active');
          });
          this.classList.add('active');
        });
      });
    }
  }

  document.addEventListener('DOMContentLoaded', function() {
    var sections = document.querySelectorAll('.d3-2000-air-pdp-scenario');
    sections.forEach(function(section) {
      initScenarioSection(section);
    });
  });

  document.addEventListener('shopify:section:load', function(event) {
    var section = event.target.querySelector('.d3-2000-air-pdp-scenario');
    if (section) {
      initScenarioSection(section);
    }
  });
})();
